/**
 * aysnc foreach function.
 * 
 * @param arr {Array}
 * @param eachFunc {Function}
 * @param doneFunc {Function}
 */
export const asyncEach = (arr, eachFunc, doneFunc) => {
    let i = -1
    let len = arr.length;

    // IIFE
    (function next(result = true) {
        let async
        let abort = result === false

        i++

        // call done function
        if (abort || i >= len) {
            doneFunc && doneFunc(!abort, arr)

            return
        }

        result = eachFunc.call({
            async() {
                async = true

                return next
            }
        }, arr[i], i, arr)

        // if not async, we should call next function
        if (!async) {
            next(result)
        }
    })()
}

/**
 * change string (with emoji) to array
 *
 * @param str {String}
 * @returns {Array}
 */
export const stringToArray = (str) => {
    const reg = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g

    let arr = []
    let result
    let start = 0
    let end = 0

    do {
        result = reg.exec(str)
        end = result ? result.index : str.length

        const resLen = result ? result[0].length : 0

        arr = arr.concat(str.substring(start, end).split(''))
        if (result) {
            arr.push(str.substring(end, (end + resLen)))
        }

        start = end + resLen

    } while (result)

    return arr
}

/**
 * @param arr
 */
export const isArray = (arr) => {
    return Object.prototype.toString.call(arr) === '[object Array]'
}

/**
 * @param obj
 */
export const isObject = (obj) => {
    return Object.prototype.toString.call(obj) === '[object Object]'
}

/**
 * deal with classname
 * @type {{add: ((ele$, cls?)), remove: ((ele$, cls?))}}
 */
export const ClassList = {
    add(ele$, cls) {
        const clsArr = ele$.className.split(/\s+/g)
        const index = clsArr.indexOf(cls)

        if (index === -1) {
            clsArr.push(cls)

            ele$.className = clsArr.join(" ")
        }
    },
    remove(ele$, cls) {
        const clsArr = ele$.className.split(/\s+/g)
        const index = clsArr.indexOf(cls)

        if (index !== -1) {
            clsArr.splice(index, 1)

            ele$.className = clsArr.join(" ")
        }
    },
}



// WEBPACK FOOTER //
// ./src/utils.js